import { render, staticRenderFns } from "./sentences-with-words.vue?vue&type=template&id=0899e8c2&"
import script from "./sentences-with-words.vue?vue&type=script&lang=js&"
export * from "./sentences-with-words.vue?vue&type=script&lang=js&"
import style0 from "./sentences-with-words.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports